<template>
  <div class="mallOrderList" >
    <el-tabs v-model="serviceStatus" class="orderListTabs" @tab-click="searchInfo">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.id"
        :label="item.name"
        :name="item.id"
      >
      </el-tab-pane>
    </el-tabs>
    <div>
      <div class="orderSearchBox">
        <!--<el-date-picker
          v-model="createDate"
          type="date"
          placeholder="创建时间"
        >
        </el-date-picker>-->
        <div class="timeSearch">
            <span style="color: #b2b2b2;">区间筛选</span>
             <el-date-picker
                v-model="createDateValue"
                @change="chooseDate"
                type="daterange"
                 value-format="yyyy-MM-dd"
                range-separator="—"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                >
            </el-date-picker>
        </div>
        <el-input v-model="serviceName" placeholder="服务名称"></el-input>
        <el-input v-model="storeName" placeholder="服务商名称"></el-input>
        <el-input v-model="orderNo" placeholder="订单编号"></el-input>
        <!--<el-select v-model="orderStatus" placeholder="订单状态">
          <el-option label="全部" value="全部"> </el-option>
          <el-option label="待确认" value="待确认"> </el-option>
          <el-option label="待付款" value="待付款"> </el-option>
        </el-select>-->
        <!-- <el-select v-model="evaluateStatusValue" placeholder="评价状态">
            <el-option
                label="已评价"
                value="已评价">
            </el-option>
            <el-option
                label="待评价"
                value="待评价">
            </el-option>
        </el-select> -->
        <!-- <el-select v-model="postSalesServiceValue" placeholder="售后服务">
          <el-option label="仅退款" value="仅退款"> </el-option>
          <el-option label="退款退货" value="退款退货"> </el-option>
          <el-option label="换货" value="换货"> </el-option>
        </el-select> -->
        <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
        <el-button type="text" class="resetBtn" @click="clearSearch">
          <i class="iconfont icon-qingchushujuku"></i>
          <span>清除条件</span>
        </el-button>
      </div>
      <div class="orderListTable">
        <ul class="tableHeader">
          <li class="name">服务名称</li>
          <li class="price">单价</li>
          <li class="num">数量</li>
          <li class="payment">实付款</li>
          <li class="status">订单状态</li>
            <li class="status">开票状态</li>
          <li class="operation">操作</li>
        </ul>
        <ul class="tableBody" v-if="serviceOrderList.length != 0" v-loading="loading">
          <li
            class="bodyItem"
            v-for="(items, index) in serviceOrderList"
            :key="index"
          >
            <div class="itemTop">
                <div>订单编号：{{ items.orderBase.orderNo }}</div>
                <div>创建时间：{{ items.orderBase.createDate }}</div>

              <div class="merchantInfo">
                  <img :src="items.storeImg" alt="" width="80px" />
                  <span>服务商：</span>
                  <span>{{items.enterPriseName}}</span>
                <!-- <i class="iconfont icon-weixin"></i> -->
              </div>
            </div>
            <div class="itemBottom">
              <div class="name">
                <div
                  class="orderInfo"
                >
                  <img :src="items.serviceImg" alt="" />
                  <div class="infoContent">
                    <div class="infoName">{{ items.serviceName }}</div>
                  </div>
                </div>
              </div>
              <div class="price">
                <div>
                  ￥{{ items.servicePrice }}
                </div>
              </div>
              <div class="num">
                <div>
                  {{ items.num }}
                </div>
              </div>
              <div class="payment">
                <h3>¥{{ items.totalPrice }}</h3>
              </div>
              <div class="status">
                <div class="statusName">{{ items.orderBase.orderStatusCn }}</div>
                <el-button type="text" class="operationBtn" @click="toDetail(items)">订单详情</el-button>
                <el-button
                  type="text"
                  class="operationBtn"
                  v-if="
                    items.orderBase.orderStatus == 'UN_RECEIVE' ||
                    items.orderBase.orderStatus == null
                  "
                  >查看物流</el-button
                >
              </div>
                <div class="status">
                    <div>{{ items.invoiceStatus==null?"未开票":items.invoiceStatus=="EXAMINE"?'开票中':items.invoiceStatus=='PASS'?'已开票':'已拒绝' }}</div>
                </div>
              <div class="operation">
                <el-button
                  type="text"
                  class="operationUploadBtn"
                  @click="submitPay(items.orderBase)"
                  v-if="items.orderBase.orderStatus == 'UN_PAY'"
                  >付款</el-button
                >
                <el-button
                  type="text"
                  class="operationUploadBtn"
                  @click="toEvaluate(items)"
                  v-if="items.orderBase.orderStatus == 'UN_APPRAISE' "
                  >评价</el-button
                >
                <el-button
                  type="text"
                  class="operationUploadBtn"
                  v-if="
                    items.orderBase.orderStatus !== 'UN_CONFIRM'
                    && items.orderBase.orderStatus !== 'UN_PAY'
                    && items.orderBase.orderStatus !== 'UN_CANCEL'
                    && items.orderBase.orderStatus !== 'DELIVERY_ON_CASH_UN_CONFIRM'
                    && items.orderBase.orderStatus !== 'AFTER_SALES'
                    && items.orderBase.afterSaleAuditStatus !== 'PASS'
                    && items.invoiceStatus === null
                  "
                  @click="openInvoice(items)"
                  >申请开票</el-button
                >
                <el-button
                  type="text"
                  class="operationUploadBtn"
                  v-if="
                    items.orderBase.orderStatus !== 'UN_CONFIRM'
                    && items.orderBase.orderStatus !== 'UN_PAY'
                    && items.orderBase.orderStatus !== 'OFFLINE_UN_CONFIRM'
                    && items.orderBase.orderStatus !== 'DELIVERY_ON_CASH_UN_CONFIRM'
                    && (items.orderBase.afterSaleUuid===null || (items.orderBase.afterSaleUuid!==null&&items.orderBase.afterSaleAuditStatus==='REJECT'))
                    && items.orderBase.splitStatus === 'NONE'
                  "
                  @click="AfterSales(items.orderBase.uuid,items.enterPriseId,items.enterPriseName,serviceStatus,items.totalPrice)"
                  >申请售后</el-button
                >
                <!--<el-button
                  type="text"
                  class="operationUploadBtn"
                  v-if="items.orderBase.orderStatus == 'UN_CONFIRM'"
                  >修改订单</el-button
                >-->
                <el-button
                  type="text"
                  class="operationUploadBtn"
                  @click="cancelOrder(items)"
                  v-if="
                    items.orderBase.orderStatus == 'UN_CONFIRM' ||
                    items.orderBase.orderStatus == 'UN_PAY' ||
                    items.orderBase.orderStatus == 'OFFLINE_UN_CONFIRM' ||
                    items.orderBase.orderStatus == 'DELIVERY_ON_CASH_UN_CONFIRM'
                  "
                  >取消订单</el-button
                >
                  <el-button
                      type="text"
                      class="operationUploadBtn"
                      @click="finishOrder(items)"
                      v-if="items.orderBase.orderStatus == 'UN_EXAMINE'"
                  >确认完成
                  </el-button
                  >
                  <el-button
                      type="text"
                      class="operationUploadBtn"
                      @click="complain(items.orderBase.uuid,items.enterPriseId,items.enterPriseName)"
                      v-if="
                      items.orderBase.orderStatus == 'OFFLINE_UN_CONFIRM' ||
                    items.orderBase.orderStatus == 'UN_EFFECT' ||
                    items.orderBase.orderStatus == 'UN_EXAMINE' ||
                    items.orderBase.orderStatus == 'UN_APPRAISE' ||
                    items.orderBase.orderStatus == 'AFTER_SALES' ||
                    items.orderBase.orderStatus == 'FINISHED'
                  "
                  >投诉
                  </el-button
                  >
              </div>
            </div>
          </li>
        </ul>
        <!-- <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div> -->
        <div class="orderNomesaage" v-loading="loading" v-else >
          <img src="../../../assets/暂无订单.jpg" alt="" style="width:200px">
        </div>
      </div>
    </div>
    <el-pagination
      v-if="serviceOrderList.length != 0"
      background
      @current-change="handleCurrentChange"
      @prev-click="handleCurrentChange"
      @next-click="handleCurrentChange"
      layout="total,prev, pager, next,jumper"
      :page-size="pageSize"
      :total="total"
      class="pagination"
    >
    </el-pagination>
    <order-dialog ref="dialogRef"></order-dialog>
      <el-dialog
          title="取消订单"
          :visible.sync="cancelDialogVisible"
          :close-on-click-modal="false"
          width="1000px">
          <div class="logisticsDialog">
              <el-form ref="logisticsForm" :rules="cancelRules" class="demo-ruleForm">
                  <el-form-item class="addressList">
                      <el-select v-model="cancelUuid" placeholder="取消原因">
                          <el-option v-for="(item,index) in cancelList" :key="index"
                                     :label="item.name"
                                     :value="item.uuid">
                          </el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item class="submitButtonGroup">
                      <el-button type="primary" @click="cancelSubmit">确定</el-button>
                      <el-button @click="cancelDialogVisible = false">取消</el-button>
                  </el-form-item>
              </el-form>
          </div>
      </el-dialog>
    <!-- 申请发票 -->
    <el-dialog title="申请发票" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="企业名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="企业税号" :label-width="formLabelWidth">
          <el-input v-model="form.number" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="开票邮箱" :label-width="formLabelWidth">
          <el-input v-model="form.email" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
      <!--评价弹出框-->
      <el-dialog title="评价" :visible.sync="evaluateDialogVisible" width="500px">
          <div class="evaluateDialogBox">
              <div class="evaluateItem">
                  <div class="name">评价等级</div>
                  <div class="content">
                      <div class="rateItem">
                          <div class="name">描述相符</div>
                          <el-rate
                              v-model="evaluateForm.descriptionPoint"
                              show-score
                              text-color="#ff9900"
                          >
                          </el-rate>
                      </div>
                      <div class="rateItem">
                          <div class="name">服务态度</div>
                          <el-rate
                              v-model="evaluateForm.servicePoint"
                              show-score
                              text-color="#ff9900"
                          >
                          </el-rate>
                      </div>
                      <div class="rateItem">
                          <div class="name">专业程度</div>
                          <el-rate
                              v-model="evaluateForm.transportPoint"
                              show-score
                              text-color="#ff9900"
                          >
                          </el-rate>
                      </div>
                  </div>
              </div>
              <div class="evaluateItem">
                  <div class="name">评价标签</div>
                  <div class="content">
                      <el-checkbox-group
                          v-model="evaluateForm.evaluationTagList"
                          class="evaluateTag"
                      >
                          <el-checkbox-button
                              v-for="tag in tagList"
                              :label="tag"
                              :key="tag.tagUuid"
                          >{{ tag.tagName }}</el-checkbox-button
                          >
                      </el-checkbox-group>
                  </div>
              </div>
              <div class="evaluateItem">
                  <div class="name">评价内容</div>
                  <div class="content">
                      <el-input
                          type="textarea"
                          :autosize="{ minRows: 6 }"
                          placeholder="请输入内容"
                          v-model="evaluateForm.evaluationContent"
                      >
                      </el-input>
                  </div>
              </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="evaluateDialogVisible = false">取 消</el-button>
            <el-button type="primary" :disabled="stepLoading" @click="evaluateSubmit">确 定</el-button>
            </span>
        </el-dialog>

      <!-- 申请开票 -->
      <issue-invoice-dialog ref="invoiceDialogRef"></issue-invoice-dialog>
        <!-- 投诉弹窗 -->
        <complaints-dialog
            ref="dialogRef"
        ></complaints-dialog>

      <!-- 购买的弹窗 -->
      <PayModelDialog ref="payModelRef" @refreshData="getServiceOrderList"/>

      <!-- 申请售后 -->
      <after-sales-dialog
          ref="afterSalesDialog"
      ></after-sales-dialog>

      <!-- 付款方式 -->
      <TermsOfPayment ref="termsOfPaymentRef" @offlinePay="offlinePayOrder"/>
    </div>
</template>

<script>
import orderDialog from "./orderDialog";
import issueInvoiceDialog from "./issueInvoiceDialog"
import complaintsDialog from './complaintsDialog'
import PayModelDialog from './payModelDialog'
import {
    getDictionaryItem,
    getServiceOrderList, updateOrderBaseInfo, updateOrderServiceInfo, saveEvaluation, offlinePay, deliveryOnCash,
} from "../../../utils/interface";
import afterSalesDialog from "./afterSalesDialog";
import TermsOfPayment from '../../../components/termsOfPayment/termsOfPayment'
export default {
  name: "mallOrderList",
    components: {
        orderDialog,
        complaintsDialog,
        issueInvoiceDialog,
        afterSalesDialog,
        PayModelDialog,
        TermsOfPayment
    },
    data() {
        return {
            stepLoading: false,
            tabList: [
                {
                    id: "",
                    name: "全部",
                },
                {
                    id: "UN_CONFIRM",
                    name: "待确认",
                },
                {
                    id: "UN_PAY",
                    name: "待付款",
                },
                {
                    id: "OFFLINE_UN_CONFIRM",
                    name: "线下支付待确认",
                },
                {
                    id: "DELIVERY_ON_CASH_UN_CONFIRM",
                    name: "货到付款待确认",
                },
                {
                    id: "UN_EFFECT",
                    name: "待实施",
                },
                {
                    id: "UN_EXAMINE",
                    name: "待完成",
                },
                {
                    id: "UN_APPRAISE",
                    name: "待评价",
                },
                {
                    id: "AFTER_SALES",
                    name: "退款/售后",
                },
            ],
            createDateValue: null,
            startTime:"",
            endTime:"",
            modelNameValue: "",
            merchantNameValue: "",
            orderNumberValue: "",
            orderStatusValue: "",
            evaluateStatusValue: "",
            postSalesServiceValue: "",
            //   分页
            pageNo: 1,
            total: 0,
            pageSize: 5,
            dialogFormVisible: false,
            form: {
                name: "",
                number: "",
                email: "",
            },
            formLabelWidth: "120px",
            order: {},
            evaluateDialogVisible: false,
            evaluateForm: {
                descriptionPoint: 0,
                servicePoint: 0,
                transportPoint: 0,
                evaluationTagList: [],
                evaluationContent: "",
            },
            tagList: [],
            loading: true,
            serviceOrderList:[],
            serviceStatus: "",
            orderNo:"",
            serviceName:"",
            createDate:null,
            storeName : "",
            // 取消
            cancelDialogVisible: false,
            uuid: "",
            cancelList: [],
            cancelUuid: "",
            orderBaseUuid: "",
            cancelRules: {
                cancelUuid: [
                    {required: true, message: '请选择取消原因', trigger: 'change'}
                ]
            },
            // 申请开票
            dialogVisibleDialog: false,
        };
    },
    created() {
        this.getServiceOrderList();
        this.getDictionaryItem();
    },
  methods: {
      // 获取字典值
      getDictionaryItem() {
          getDictionaryItem({groupCode: "service_evaluation_tag"}).then((res) => {
              this.tagList = [];
              res.forEach((item, index) => {
                  this.tagList.push({tagName: item.name, tagUuid: item.code, tagGroupId: item.groupUuid});
              });
          });
      },
      // 检索重置
      clearSearch() {
          this.serviceName = '';
          this.orderNo = '';
          this.serviceStatus = '';
          this.storeName = '';
          this.evaluateStatusValue="";
          this.postSalesServiceValue="";
          this.createDate = null;
          this.createDateValue = null;
          this.startTime = "";
          this.endTime = "";
          this.searchInfo();
      },
      searchInfo(){
          this.pageNo = 1;
          this.getServiceOrderList();
      },
      getServiceOrderList(){
          this.loading = true
          let params = {
              serviceName: this.serviceName,
              orderNo: this.orderNo,
              serviceStatus: this.serviceStatus ==0?"":this.serviceStatus,
              storeName : this.storeName,
              //createDate:this.createDate==null?null : this.createDate.getFullYear() +'-'+ (this.createDate.getMonth() + 1) +'-'+this.createDate.getDate(),
              startDate:this.startTime,
              endDate:this.endTime,
              current: this.pageNo,
              pageSize: this.pageSize,
              isBuy : true,
          };
          getServiceOrderList(params).then((res) => {
              this.serviceOrderList = res.list;
              this.total = res.total;
              this.loading = false
          });
      },
      handleSizeChange(val) {
          this.pageSize = val;
      },
      handleCurrentChange(val) {
          this.pageNo = val;
          this.getServiceOrderList();
      },
      // 时间格式
      chooseDate(){
          this.startTime = "";
          this.endTime = "";
          // 判断时间
          if(this.createDateValue!=null && this.createDateValue.length==2){
              this.startTime = this.timeDate(this.createDateValue[0]);
              this.endTime = this.timeDate(this.createDateValue[1]);
          }
      },
      timeDate(value){
          let date = new Date(value);
          let y = date.getFullYear();
          let MM = date.getMonth() + 1;
          MM = MM < 10 ? "0" + MM : MM;
          let d = date.getDate();
          d = d < 10 ? "0" + d : d;
          return y + "-" + MM + "-" + d;
      },
      // 跳转至详情页
      toDetail(val) {
          this.$router.push({name:'serverOrderDetails',params:{uuid:val.uuid}});
      },
      // 支付
      submitPay(item){
          this.order = item;
          // 付款的选择弹窗
          this.$refs.termsOfPaymentRef.init(item)
          /*updateOrderBaseInfo({uuid:item.orderBase.uuid,orderStatus:"UN_SEND"}).then((res)=>{
              if(res.success){
                  updateOrderServiceInfo({uuid:item.uuid,serviceStatus:"UN_EFFECT"}).then((res)=>{
                      if(res.success){
                          this.$message.success('订单支付成功！');
                          this.getServiceOrderList();
                      }
                  });
              }
          });*/
      },
      //线下支付上传凭证
      offlinePayOrder(obj){
          if(obj.radio == 1){
              this.$refs.payModelRef.init();
              window.open(this.$url.payUrl + this.order.orderNo, "_blank");
          } else if(obj.radio == 2 && obj.imageUrl != '' && obj.imageUrl != null){
              let form ={orderNo: this.order.orderNo, orderBaseUuid: this.order.uuid, payTicket: obj.imageUrl};
              offlinePay(form).then(res=> {
                  console.log(res);
                  if (res && res.success) {
                      this.$message.success(res.message);
                      this.getServiceOrderList();
                  }else {
                      this.$message.error(res.message);
                  }
                  this.order = {};
              });
          } else if(obj.radio == 3){
              let form ={orderNo: this.order.orderNo, orderBaseUuid: this.order.uuid};
              deliveryOnCash(form).then(res=> {
                  console.log(res);
                  if (res && res.success) {
                      this.$message.success(res.message);
                      this.getServiceOrderList();
                  }else {
                      this.$message.error(res.message);
                  }
              });
          }
      },
      // 取消
      cancelOrder(item){
          getDictionaryItem({groupCode:"service_cancel_reason"}).then((res)=>{
              this.cancelList = res;
              this.uuid = item.uuid;
              this.orderBaseUuid = item.orderBase.uuid;
              this.cancelDialogVisible = true;
          });
      },
      // 取消确定
      cancelSubmit(){
          if(this.cancelUuid==""){
              this.$message.error('请选择取消原因！');
              return false;
          }
          updateOrderBaseInfo({uuid:this.orderBaseUuid,orderStatus:"UN_CANCEL",cancelOrderUuid:this.cancelUuid}).then((res)=>{
              if(res.success){
                  updateOrderServiceInfo({uuid:this.uuid,serviceStatus:"UN_CANCEL"}).then((result)=>{
                      if(result.success){
                          this.$message.success('订单取消成功！');
                          this.cancelDialogVisible = false;
                          this.getServiceOrderList();
                      }
                  });
              }
          });
      },
      // 点击打开评价弹出框
      toEvaluate(order) {
          this.order = order;
          this.evaluateForm = {
              descriptionPoint: 0,
              servicePoint: 0,
              transportPoint: 0,
              evaluationTagList: [],
              evaluationContent: "",
          };
          this.evaluateDialogVisible = true;
      },
      // 评价提交
      evaluateSubmit() {
          this.stepLoading = true;
          if (
              this.evaluateForm.descriptionPoint &&
              this.evaluateForm.servicePoint &&
              this.evaluateForm.transportPoint
          ) {
              this.evaluateForm.orderNo = this.order.orderBase.orderNo;
              this.evaluateForm.orderUuid = this.order.uuid;
              this.evaluateForm.orderType = 'SERVICE';
              this.evaluateForm.evaluationType = 'NORMAL';
              this.evaluateForm.sellerName = this.order.enterPriseName;
              this.evaluateForm.sellerUuid = this.order.enterPriseId;
              this.evaluateForm.orderName = this.order.serviceName;
              this.evaluateForm.orderAmount = this.order.orderBase.totalPrice;

              saveEvaluation(this.evaluateForm).then((response) => {
                  if (response.success) {
                      this.evaluateDialogVisible = false;
                      this.getServiceOrderList();
                      this.$message({
                          type: "success",
                          message: "评价成功",
                      });
                  } else {
                      this.$message({
                          type: "error",
                          message: response.message,
                      });
                  }
              });
          } else {
              this.$message.warning("请选择评价等级");
          }
          setTimeout(() => {
              this.stepLoading = false;
          }, 1000);
      },
      finishOrder(item){
          this.$confirm('确认完成订单?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              // 未支付
              item.orderBase.orderStatus = "UN_APPRAISE";
              updateOrderBaseInfo(item.orderBase).then((res)=>{
                  if(res.success){
                      updateOrderServiceInfo({uuid:item.uuid,serviceStatus:"UN_APPRAISE"}).then((res)=>{
                          if(res.success){
                              this.$message.success('订单已完成！');
                              this.getServiceOrderList();
                          }
                      });
                  }
              });
          });
      },
      // 申请开票
      openInvoice(item){

          let params = {uuid:item.issueInvoiceUuid,
                        orderUuid:item.orderBaseUuid,
              orderNo:item.orderBase.orderNo,
              orderName:item.serviceName,
              orderImg:item.serviceImg,
              orderType:'SERVICE',
              issueUser:item.userUuid,
              invoiceMoney:item.totalPrice,
          }
          this.$refs.invoiceDialogRef.init(params);
      },
      complain(orderBaseUuid, targetUserUuid, enterPriseName) {
          this.$refs.dialogRef.init(orderBaseUuid, targetUserUuid, enterPriseName);
      },
      // 申请售后
      AfterSales(orderBaseUuid, targetUserUuid, enterPriseName, orderStatus, orderPrice){
          this.$refs.afterSalesDialog.init(orderBaseUuid, targetUserUuid, enterPriseName, 'SERVICE', orderStatus, orderPrice)
      }
  },
};
</script>

<style scoped lang="less">
.mallOrderList {
  padding: 94px 20px 20px;
  .orderListTabs {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    background: #fff;
    width: 100%;
    padding: 20px;
  }
  /deep/ .el-tabs__item {
    padding: 0 25px !important;
    text-align: center;

    &:hover {
      color: #3686d7;
    }

    &:after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 12px;
      width: 1px;
      height: 15px;
      background-color: #e4e7ed;
      z-index: 1;
    }

    &:last-child:after {
      content: "";
      width: 0;
      height: 0;
    }
  }

  /deep/ .el-tabs__active-bar {
    height: 3px;
    background-color: #3686d7;
  }

  /deep/ .el-tabs__item.is-active {
    color: #3686d7;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
  }

  .orderSearchBox {
    display: flex;
    flex-wrap: wrap;
.timeSearch{
                background-color:#f2f4f7;
                height: 35px;
                display: flex;
                align-items: center;
                margin-bottom: 22px;
                margin-right: 30px;
                border-radius: 8px;
                span{
                    font-size: 12px;
                    color: #c0c4cc!important;
                    font-weight: normal;
                    padding-left: 15px;
                    margin-right: 5px;
                }
                // /deep/ .el-range-input{
                //         background-color: #f2f4f7;
                //             &:hover, &:focus {
                //             background-color: #fff;
                //             // border: 1px solid #108EE9;
                //         }
                // }
                /deep/input::-webkit-input-placeholder {
                    color: #c0c4cc;
                    font-size: 12px;
                }
              /deep/.el-range-input:hover{
                  background-color: #fff!important;
              }
              /deep/ .el-date-editor .el-range-separator{
                  line-height: 25px;
                  color: #c0c4cc;
              }
             /deep/ .el-date-editor .el-range__close-icon{
                 line-height: 28px;
             }
              /deep/ .el-input__inner:hover  .el-range-input, /deep/ .el-input__inner:focus  .el-range-input{
                  background-color: white;
              }
                /deep/ .el-input__inner {
                width: 225px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;
                .el-range-input{
                    background-color:#f2f4f7 ;
                }

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;

                }
            }
            /deep/ .el-icon-date:before {
                    content: "\E78E";
                    display: none;
                }
                /deep/.el-input__icon{
                    // display: none;
                }
            }
    /deep/ .el-input {
      width: initial;
      margin-bottom: 22px;
      margin-right: 30px;
    }

    /deep/ .el-input__inner {
      width: 242px;
      height: 35px;
      min-height: 35px;
      font-size: 12px;
      color: #999999;
      background-color: #f2f4f7;
      border: 1px solid #f2f4f7;
      border-radius: 5px;

      &:hover,
      &:focus {
        background-color: #fff;
        border: 1px solid #108ee9;
      }
    }

    /deep/ .el-input__prefix {
      top: -3px;
    }

    /deep/ .el-input__suffix {
      top: 2px;
    }

    /deep/ .el-button {
      display: block;
      line-height: 35px;
      padding: 0;
      height: 35px;
    }

    .searchBtn {
      width: 82px;
      background: #3d7fff;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
        margin-bottom: 22px;
    }

    .resetBtn {
      color: #333333;
        margin-bottom: 22px;
    }
  }

  .orderListTable {
    .orderNomesaage {
        color: #888;
        text-align: center;
        padding: 15px 0;
    }
    .tableHeader {
      display: flex;
      width: 100%;
      height: 35px;
      line-height: 35px;
      background: #f3f7ff;
      border-radius: 5px;
      margin: 0 0 15px;
      li {
        text-align: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
    }

    .tableBody {
      li {
        width: 100%;
        border: 1px solid #f2f2f2;
        border-radius: 10px;
        margin-bottom: 16px;

        .itemTop {
          width: 100%;
          height: 42px;
          background: #ebf3fb;
          line-height: 42px;
          font-size: 14px;
          color: #333;
          padding: 0 20px;
          display: flex;
          align-items: center;
          position: relative;

          div {
            margin-right: 30px;
          }

          .merchantInfo {
            display: flex;
            align-items: center;

            i {
              color: #3d7fff;
              font-size: 25px;
              cursor: pointer;
              padding-left: 5px;
              display: block;
            }

            img {
              display: block;
              padding-right: 5px;
            }
          }

          .complainBtn {
            color: #999;
            position: absolute;
            right: 20px;
          }
        }

        .itemBottom {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 13px;

          .orderInfo {
            padding: 20px;
            display: flex;
            align-items: center;

            img {
              display: block;
              width: 147px;
              height: 83px;
              border-radius: 10px;
              margin-right: 30px;
            }

            .infoContent {
              .infoName {
                font-size: 14px;
                color: #000000;
                padding-bottom: 10px;
              }

              .infoOther {
                font-size: 13px;
                color: #999999;
                padding-bottom: 8px;
              }
            }
          }

          .arguments {
            padding: 20px;
          }

          .argumentsName {
            padding-bottom: 8px;
          }
          .payment {
            h3 {
              font-size: 14px;
              font-weight: 700;
              margin: 0;
            }

            .title {
              font-size: 12px;
              color: #999999;
            }
          }
          .status {
            font-size: 14px;
          }
          .operationBtn {
            display: block;
            color: #0c75d3;
            text-align: center;
            width: 100%;
            margin: 0;
          }
          .operationBtnMoney {
            color: #0c75d3;
            padding: 6px 20px;
            border: 1px solid #0c75d3;
            border-radius: 6px;
          }
        }
      }
    }

    .name {
      flex: 1;
      border-right: 1px solid #efefef;
    }

    .price {
      width: 13%;
      text-align: center;
    }

    .num {
      width: 13%;
      text-align: center;
    }

    .arguments {
      width: 10%;
    }

    .payment {
      width: 14%;
      text-align: center;
    }

    .status {
      width: 10%;
      text-align: center;
    }

    .operation {
        width: 10%;
        text-align: center;
        .operationUploadBtn{
            width: 102px !important;
            height: 34px;
            padding: 0;
            line-height: 34px;
            text-align: center;
            font-weight: 700;
            color: rgba(0, 102, 204, 0.8);
            font-size: 14px;
            border-color: rgba(0, 102, 204, 0.8);
            display: block;
            margin: 0 auto 10px !important;
        }
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
    .electronicInvoice {
        h3 {
            padding-bottom: 15px;
            color: #000;
            font-size: 15px;
        }

        .invoiceList {
            .invoiceItem {
                border: 1px solid #ddd;
                padding: 10px 50px 10px 15px;
                border-radius: 10px;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                position: relative;

                .invoiceCheckBox {
                    padding-right: 15px;
                }

                .type {
                    font-size: 12px;
                    color: #666;
                    padding-bottom: 5px;
                }

                .name {
                    font-size: 15px;
                    color: #000;
                    padding-bottom: 5px;
                }

                .num {
                    font-size: 12px;
                    color: #333;
                }

                .edit {
                    position: absolute;
                    right: 15px;
                    top: 50%;
                    margin-top: -10px;
                    padding: 0;
                }
            }
        }

        .emailList {
            padding: 0 15px 15px;

            /deep/ .el-radio {
                margin-bottom: 15px;
                display: block;
                margin-right: 0;
            }
        }
    }
    .addressList{
        padding: 24px 15px 0;
        display: flex;
        flex-wrap: wrap;
        .addressItem{
            padding: 14px 22px;
            margin-bottom: 24px;
            margin-right: 30px;
            position: relative;
            width: 270px;
            border-radius: 8px;
            border: 2px dashed #E3E3E3;
            font-size: 14px;
            .addressBorder{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
            &.active{
                border: 2px dashed #fff;
            }
            &:nth-of-type(4n){
                margin-right: 0;
            }
            .checkBox{
                position: absolute;
                right: 22px;
                top: 14px;
            }
            .name{
                color: #000;
            }
            .tel{
                color: rgba(51, 51, 51, 0.85);
                padding: 6px 0;
            }
            .address{
                color: rgba(51, 51, 51, 0.85);
                line-height: 22px;
            }
        }
        .addItem{
            text-align: center;
            cursor: pointer;
            color: #666;
            &:hover{
                border: 2px dashed #1890FF;
            }
            .icon{
                font-size: 30px;
            }
            .addName{
                font-size: 14px;
                padding-top: 5px;
            }
        }
    }
}
    .evaluateDialogBox {
        .evaluateItem {
            .name {
                font-size: 14px;
                color: #000;
                padding-bottom: 20px;
                font-weight: bold;
            }

            .content {
                padding-left: 20px;
                padding-bottom: 15px;
            }

            .rateItem {
                display: flex;
                align-items: center;
                padding-bottom: 15px;

                .name {
                    padding: 0 20px 0 0;
                    font-size: 13px;
                    color: #333;
                    min-width: 100px;
                    font-weight: normal;
                }
            }

            .evaluateTag {
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-checkbox-button {
                    display: block;
                    margin-right: 20px;
                    margin-bottom: 15px;

                }

                /deep/ .el-checkbox-button__inner {
                    border: 1px solid #DCDFE6 !important;
                    border-radius: 4px;
                    padding: 8px 15px;
                    font-size: 13px;
                    box-shadow: none;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/severOrderList.vue